module.exports = __webpack_public_path__ + "img/lumilive_2.46bb9152.png";